const TITLE = "Job hunting? Apply today at monday.com";
const DESCRIPTION = "Join our team so together we can impact how teams work across the globe. View all open positions.";
const INTERNAL_JOBS_TITLE = "Internal mobility at monday.com";
const INTERNAL_JOBS_DESCRIPTION = "Explore different opportunities within monday.com that may suit you and the company's needs.";
const META_OVERRIDE = {
    facebookMetaOverride: {
        imagePath: "https://s3.amazonaws.com/general-assets/careers/social-assets/monday-1200_628.png"
    },
    twitterMetaOverride: {
        imagePath: "https://s3.amazonaws.com/general-assets/careers/social-assets/monday-800_418.png"
    }
};
const POSITION_TYPE_CATEGORY_NAME = "Publish Position";
const POSITION_TYPE_INTERNAL = "internal";
const POSITION_TYPE_EXTERNAL = "external";
const POSITION_TYPE_INTERNAL_VALUE = "Internal Career Site";
const POSITION_TYPE_EXTERNAL_VALUE = "Monday Careers";
const POSITION_TYPE_INTERNAL_AND_EXTERNAL_VALUE = "Both";
const CAREERS_ROOT_URL = "/careers/";
const INTERNAL_CAREERS_ROOT_URL = "/internal-careers/";
const PRIVACY_NOTICE_URL = "https://dapulse-res.cloudinary.com/raw/upload/remote_mondaycom_static/uploads/monday.com_-_Job_Candidate_Privacy_Notice.docx";
const PRIVACY_NOTICE_TEXT = "Review our job candidate privacy notice";
const SEARCH_DEBOUNCE_RATE = 300;
const getCareersRootUrl = (positionsType)=>{
    return positionsType === POSITION_TYPE_INTERNAL ? INTERNAL_CAREERS_ROOT_URL : CAREERS_ROOT_URL;
};
module.exports = {
    META_OVERRIDE,
    TITLE,
    DESCRIPTION,
    POSITION_TYPE_CATEGORY_NAME,
    POSITION_TYPE_INTERNAL,
    POSITION_TYPE_INTERNAL_VALUE,
    POSITION_TYPE_EXTERNAL_VALUE,
    POSITION_TYPE_INTERNAL_AND_EXTERNAL_VALUE,
    POSITION_TYPE_EXTERNAL,
    INTERNAL_JOBS_TITLE,
    INTERNAL_JOBS_DESCRIPTION,
    CAREERS_ROOT_URL,
    INTERNAL_CAREERS_ROOT_URL,
    SEARCH_DEBOUNCE_RATE,
    PRIVACY_NOTICE_URL,
    PRIVACY_NOTICE_TEXT,
    getCareersRootUrl
};
